import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../components/info/DisplayError';
import Loading from '../../../../components/info/Loading';
import { StudentsRemovalRequestDetailResponse } from '../types/students';
import { getRequestDetail } from '../api';

interface StudentsRemovalRequestDetailLoaderProps {
  studyPlanEnrollmentId: number;
  children: (props: {
    data: StudentsRemovalRequestDetailResponse;
  }) => ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  StudentsRemovalRequestDetailResponse
>();

export function useIdentificationTypeLoader() {
  return useFetch();
}

export function StudentsRemovalRequestDetailLoader({
  studyPlanEnrollmentId,
  children,
}: StudentsRemovalRequestDetailLoaderProps) {
  const request = useCallback(() => {
    return getRequestDetail(studyPlanEnrollmentId);
  }, [studyPlanEnrollmentId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
